import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { NgxSmartModalComponent } from 'ngx-smart-modal';
import { Subject } from 'rxjs';
import { Patterns, setTimeout$, Utility } from 'src/app/core/common';
import { DateConstants } from 'src/app/core/persian-date';
import { Current } from 'src/app/states/auth.state';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { CollectService } from 'src/app/services/collect.service';
import { KarpashaService } from 'src/app/services/karpasha.service';
// import { NpsService } from 'src/app/services/nps.service';
import { PushService } from 'src/app/services/push.service';
import { SharedService } from 'src/app/services/shared.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';
import { SearchParams } from 'src/app/common';

@Component({
  selector: 'app-questioner',
  templateUrl: './questioner.component.html',
  styleUrls: ['./questioner.component.scss']
})
export class QuestionerComponent implements OnInit {
  user: any;
  question: any;
  @Input('search-params') searchParams: SearchParams;
  @Input() snoozable = true;
  assetsUrl = environment.app.assetsUrl;
  patterns = Patterns;
  @Input() suggestions: any;
  pushStatus: string;
  @Output('question-key') onQuestion = new EventEmitter<string>();
  @Output('login') onLogin = new EventEmitter();
  @Input('hide-header') hideHeader: boolean;

  constructor(private store: Store, private userService: UserService, private spinner: SpinnerService,
    private router: Router, private collectService: CollectService, public pushService: PushService, karpashaService: KarpashaService,
    private route: ActivatedRoute, private sharedService: SharedService, private analyticsService: AnalyticsService) {
  }

  async ngOnInit() {

    await this.load(false);
  }

  async load(reload?: boolean) {
    try {
      if (reload != false && this.searchParams && typeof (this.searchParams) != 'boolean') {
        await this.collectService.jobSearch(this.searchParams.q, Utility.locationSearch(this.searchParams.state, this.searchParams.city), {});
        this.location = { State: this.searchParams.state, City: this.searchParams.city };
        reload = true;
      }
      if (reload && (!this.suggestions || ['User-Suggest', 'User-NoSuggest', 'Seeker.Skills', 'Seeker.JobAlertSettings.Searches'].includes(this.questionKey)))
        this.suggestions = await this.userService.suggest(false, null, this.searchParams);

      if (this.snoozedUntil > new Date()) {
        delete this.question;
        return;
      }

      await this.loadUser();

      if (this.user && this.route.snapshot.queryParams['pid'])
        this.question = this.list.find(_ => _.key == 'Seeker.ExpiredPromote');
      else this.question = this.questions[0];

      if (this.sharedService.isBrowser && this.question) {
        this.analyticsService.gtmEvent(this.questionKey, 'questioner', 'ask', true);
      }

      this.userSuggestion = this.suggestions && this.suggestions['searches']?.length ? 'searches' : 'skills';

      this.onQuestion.emit(this.questionKey);
    } finally { this.spinner.hide('questioner-wizard'); }
  }

  private unsubscribe$ = new Subject<void>();
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  set show(show: boolean) { localStorage['questioner-intro'] = show; }
  get show() { return true || localStorage['questioner-intro'] == 'true'; }

  snooze() {
    this.snoozedUntil = new Date(Date.now() + (this.question?.snooze || 1) * DateConstants.oneHour);
    this.load();
  }
  set snoozedUntil(snooze: Date) { localStorage['questioner-snooze'] = snooze.getTime(); }
  get snoozedUntil() { return new Date(+localStorage['questioner-snooze']); }

  location: any = {};
  locationInfo: any = { AllowedDistance: 0 };

  get questionKey() {
    return this.question?.key || this.question;
  }

  isSkipped(key: string) {
    var skipped = localStorage[`question-skipped-${key}`];
    return skipped && +skipped > Date.now() - DateConstants.oneDay * 3;
  }
  skip(key?: string) {
    this.spinner.show('questioner-wizard');
    localStorage[`question-skipped-${key || this.questionKey}`] = Date.now();
    this.load();
  }

  getArray(type: string) { try { return JSON.parse(localStorage[`question-selection-${type}`]) || []; } catch { return []; } }
  toggleInArray(type: string, item: string) {
    var array = this.getArray(type);
    var i = array.indexOf(item);
    if (i < 0) array.push(item);
    else array.splice(i, 1);
    localStorage[`question-selection-${type}`] = JSON.stringify(array || []);
  }
  includesInArray(type: string, item: string) {
    return this.getArray(type).includes(item);
  }
  addInArray(type: string) {
    if (!this.suggestions?.[type]) return;
    var item = this.suggestions[type]._new;
    this.suggestions[type].splice(0, 0, item);
    this.toggleInArray(type, item);
    delete this.suggestions[type]._new;
  }

  hasSuggestion(type: string) {
    if (!this.user?.Seeker) return false;
    switch (type) {
      case 'skills': return this.user.Seeker.Skills?.length > 0;
      case 'searches': return this.user.Seeker.JobAlertSettings?.Searches?.length > 0;
      case 'positions': return this.user.Seeker.Experiences?.length > 0;
    }
    return false;
  }

  get questions() {
    return this.list.filter(_ => {
      try {
        if (this.isSkipped(_.key || _)) return false;
        return _.check ? _.check() : ((Utility.getProperty(this.user, _) || '') == '');
      } catch { return false; }
    });
  }

  @Input('suggestion-page') suggestionPage = 5;
  userSuggestion = 'searches';
  userSuggestionMessage: any = {
    'skills': 'چندتا از این مهارت‌ها رو داری؟',
    'searches': 'اگر بخوای بین همه‌ی آگهی‌های استخدام ایران جستجو کنی، چنتا از نزدیکترین جستجوهات کدوماس؟',
    'positions': 'از بین این مشاغل تجربه‌ی کدوم‌ها رو داری؟',
  };
  userNoSuggestionMessage: any = {
    'skills': 'مهارت‌هایی که بلدی رو وارد کن',
    'searches': 'اگر بخوای بین همه‌ی آگهی‌های استخدام ایران جستجو کنی، چنتا از نزدیکترین جستجوهات رو وارد کن',
    'positions': 'شغل‌هایی که قبلا تجربه کردی رو وارد کن',
  };

  // _askNps: boolean;
  // @Input('ask-nps') get askNps() { return this._askNps; }
  // set askNps(askNps: boolean) {
  //   this._askNps = askNps;
  //   this.load();
  // }

  list: any[] = [
    { key: 'Karpasha', check: () => !this.user?.Seeker?.KarpashaProgress, hideBtn: () => true, hideHeader: () => true, login: true },
    {
      key: 'User-Suggest',
      check: () => ((this.suggestions && this.suggestions[this.userSuggestion]?.length) || !this.searchParams?.q) && !this.hasSuggestion(this.userSuggestion),
      hideBtn: () => !this.getArray(this.userSuggestion)?.length,
      login: true
    },
    {
      key: 'User-NoSuggest',
      check: () => (this.suggestions && !this.suggestions[this.userSuggestion]?.length) && this.searchParams?.q && !this.hasSuggestion(this.userSuggestion),
      hideBtn: () => !this.getArray(this.userSuggestion)?.length,
      login: true
    },
    {
      key: 'Seeker.JobAlertSettings.AllowedDistance',
      check: () => !this.locationInfo._filled,
      login: true
    },
    {
      key: 'Seeker.Skills',
      check: () => this.suggestions?.skills?.length && !this.user.Seeker?.Skills?.length
    },
    {
      key: 'Seeker.JobAlertSettings.Searches',
      check: () => this.suggestions?.searches?.length && !this.user.Seeker?.JobAlertSettings?.Searches?.length
    },
    { key: 'Seeker.Gender', check: () => +this.user.Seeker.Gender == -1, hideBtn: () => true },
    { key: 'Seeker.MilitaryStatus', check: () => this.user.Seeker?.Gender == 0 && !this.user.Seeker?.MilitaryStatus },
    // 'Seeker.MaritalStatus',
    {
      key: 'Seeker.ExpiredPromote', check: () => !this.user?.Seeker || this.user.Seeker.ExpiredPromote,
      hideBtn: () => true, hideHeader: () => true
    },
    // 'Name',
    // 'Seeker.Photo',
    // 'Seeker.Email',
    // 'Seeker.Birthday',
    // 'Seeker.District',
    // 'Seeker.About',
    // 'Seeker.LanguageSkills',
    // 'Seeker.Educations',
    // { key: 'Seeker.Experiences', check:  () => !this.user.Seeker?.Experiences?.length },
  ];

  async loadUser() {
    this.user = Utility.clone(this.store.selectSnapshot(state => state.auth.user));
    if (!this.user) return;

    if (!this.user.Seeker) this.user.Seeker = { ExpiredPromote: true };
    if (!this.user.Seeker.Skills) this.user.Seeker.Skills = [];
    if (!this.user.Seeker.Experiences) this.user.Seeker.Experiences = [];
    if (!this.user.Seeker.JobAlertSettings) this.user.Seeker.JobAlertSettings = {};
    if (!this.user.Seeker.JobAlertSettings.Searches) this.user.Seeker.JobAlertSettings.Searches = [];

    if (this.user.Seeker.State && this.user.Seeker.City) {
      this.location = {
        State: this.user.Seeker.State,
        City: this.user.Seeker.City
      };
      this.locationInfo = {
        _filled: !(this.user.Seeker.JobAlertSettings.AllowedDistance == null && this.user.Seeker.JobAlertSettings.ReadyToRelocate == null),
        District: this.user.Seeker.District,
        AllowedDistance: this.user.Seeker.JobAlertSettings.ReadyToRelocate ? null : 0
      };
    }
  }

  openToWork = true;

  @ViewChild('loginModal') loginModal: NgxSmartModalComponent;
  async update(load = false) {
    this.spinner.show('questioner-wizard');
    if (load) {
      this.loginModal.close();
      await this.loadUser();
    }

    var location = this.location;
    if (location && (this.user.Seeker.State != location.State || this.user.Seeker.City != location.City)) {
      this.user.Seeker.State = location.State;
      this.user.Seeker.City = location.City;
      this.user.Seeker.District = location.District;
    }
    if (this.locationInfo) {
      this.user.Seeker.JobAlertSettings.AllowedDistance = this.locationInfo.AllowedDistance;
      this.user.Seeker.JobAlertSettings.ReadyToRelocate = this.locationInfo.AllowedDistance == null ? true : null;
    }

    this.user.Seeker.JobAlertSettings.OpenToWork = this.openToWork;

    var skills = this.getArray('skills');
    if (skills?.length)
      this.user.Seeker.Skills.push(...(skills?.
        filter(_ => _ && !this.user.Seeker.Skills.find(s => s.Title == _)).
        map(_ => ({ Title: _ })) || []));

    var positions = this.getArray('positions');
    if (positions?.length)
      this.user.Seeker.Experiences.push(...(positions?.
        filter(_ => _ && !this.user.Seeker.Experiences.find(s => s.Position == _)).
        map(_ => ({ Position: _ })) || []));

    var searches = this.getArray('searches');
    if (searches?.length) {
      location = this.user.Seeker.JobAlertSettings.ReadyToRelocate == true ? null :
        { State: this.user.Seeker.State, City: this.user.Seeker.City };
      this.user.Seeker.JobAlertSettings.Searches.push(...(searches?.
        filter(_ => _ && !this.user.Seeker.JobAlertSettings.Searches
          .find(s =>
            (s.SearchParams?.q == _ && s.SearchParams?.state == location?.State && s.SearchParams?.city == location?.City) ||
            (s.Keyword == _ && s.Location?.State == location?.State && s.Location?.City == location?.City))
        ).map(_ => ({
          IsVerified: true,
          SubscribeSource: 'questioner',
          SearchParams: {
            q: _, state: location?.State, city: location?.City,
            dist: location ? this.user.Seeker.JobAlertSettings.AllowedDistance : null
          }
        })) || []));
    }

    await this.userService.saveResume(this.user);
    await this.store.dispatch(Current).toPromise();

    this.analyticsService.gtmEvent(this.questionKey, 'questioner', 'answer');

    await this.load(true);

    this.hideHeader = true;
    this.spinner.hide('questioner-wizard');
    this.onLogin.emit();
    setTimeout$(() => this.sharedService.scrollIntoView('.kp-questioner'), 500);
  }

  async uploadPhoto(image: File) {
    if (!image) return;
    if (image.size > 2 * 1024 * 1024) {
      alert('حجم فایل عکس باید کمتر از 2 مگابایت باشد');
      return;
    }
    await this.userService.uploadPhoto(image, this.user.Id);
    await this.update();
  }

  async requestPermission() {
    await this.pushService.requestPermission();
  }

  removePid() {
    this.router.navigate([], {
      queryParams: { 'pid': null },
      queryParamsHandling: 'merge'
    });
  }

  // async answerAgent(accept: boolean, note = '') {
  //   this.spinner.show('questioner-wizard');
  //   if (this.user) 
  //     await this.userService.assignAgent("-1", accept, note, []);
  //   this.router.navigate(['/seeker', 'karpasha']);
  // }

  // npsReady(ready: boolean) {
  //   this.load();
  // }
}
